const ArrowForwardIcon = () => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51" width="100%" height="100%" fill="currentColor">
<polygon points="29.1,44 26.1,41 39.5,27.6 6.4,27.6 6.4,23.4 39.6,23.4 26.1,10 29.1,7 47.7,25.4 47.7,25.4 47.7,25.5 "/>
</svg>`;
export default ArrowForwardIcon;
